<template>
  <Head>
  <title>Sizing Calculator | NutriStudents K-12</title>
  <meta name="description" content="Sizing Calculator">
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <U>Tools</U>
    </BreadcrumLayout>
    <PageTitleLayout>

      <div class="lg:mb-0 mb-4 w-full">
        <h1 class="heading-color xl:text-4xl text-2xl font-bold">Sizing Calculator</h1>
      </div>
      <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center">

      </div>
    </PageTitleLayout>

    <div class="xl:flex w-full xl:px-10 px-5 xl:pt-10 pt-5 lg:mb-10 mb-5 justify-between items-end">
    <div class="flex flex-wrap items-end -mx-2 w-full xl:w-auto">
      
      <div class="px-2 w-full sm:w-1/2 lg:w-56 mb-4 xl:mb-0">
        <label for="" class="font-bold text-black-800 uppercase text-sm">Search</label>
        <div class="relative w-full" ref="searchContainer">
          <input class="border-2 border-gray-300 bg-white h-10 px-3 pr-10 rounded-lg text-sm focus:outline-none w-full" type="text" name="searchByName" placeholder="Search Recipe" v-model="searchByName"  @input="onQueryChange" >
          <!-- Search Suggestions -->
          <ul v-if="searchSuggestions.length > 0 && showSuggestions" class="absolute z-50 w-full bg-white border border-gray-300 rounded-lg shadow-lg mt-1 max-h-60 overflow-y-auto">
              <li v-for="sugg in searchSuggestions" :key="sugg.id" @click.stop="toggleSelectionFromSuggestion(sugg)" :class="{'bg-blue-100': isRecipeSelected(sugg)}" class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm font-semibold">
                 {{ sugg.name }}
              </li>
          </ul>
        </div>
      </div>

      <div class="px-2 w-full sm:w-full lg:w-auto mb-4 xl:mb-1 flex justify-center text-center">
        <span class="font-bold text-gray-500 uppercase text-sm lg:pb-1">OR</span>
      </div>

      <div class="px-2 w-full sm:w-1/2 lg:w-48 mb-4 xl:mb-0">
        <label for="" class="font-bold text-black-800 uppercase text-sm">Date</label>
        <input class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height" type="date" v-model="form.date" />
      </div>

      <div class="px-2 w-full sm:w-1/2 lg:w-48 mb-4 xl:mb-0">
        <label for="" class="font-bold text-black-800 uppercase text-sm">Site/Group</label>
        <div class="relative">
          <select class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height" v-model="form.site" @change="getOffering($event)">
            <option value="">Choose Site/Group</option>
            <optgroup label="Site">
              <option type="site" v-for="site in sites" :value="site.id">{{ site.name }}</option>
            </optgroup>
            <optgroup label="Groups">
              <option type="group" v-for="site in mealPreparationGroups" :value="site.id">{{ site.name }}</option>
            </optgroup>
          </select>
          <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white bottom-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
      </div>

      <div class="px-2 w-full sm:w-1/2 lg:w-48 mb-4 xl:mb-0">
        <label for="" class="font-bold text-black-800 uppercase text-sm">Offering</label>
        <div class="relative">
          <select class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height" v-model="form.offer">
            <option value="">Choose Offerings</option>
            <option v-for="offer in offerings" :value="offer.id">{{ offer.name }}</option>
          </select>
          <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white bottom-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    
    <div class="w-full xl:w-auto flex flex-wrap sm:flex-nowrap justify-start sm:justify-end xl:justify-end items-end mt-2 xl:mt-0 xl:mb-1 -mx-2 xl:mx-0">
      <div class="w-full sm:w-auto px-2 mb-4 xl:mb-0">
        <button @click="resetSeatch" class="button-color w-full sm:w-auto text-white font-bold flex items-center justify-center h-10 rounded px-4 whitespace-nowrap shadow-sm">
          View Selected
        </button>
      </div>

      <div v-if="exportAssembly.length > 0 || exportRecipe.length > 0 || exportRecipeSearced.length > 0" class="w-full sm:w-auto px-2 mb-4 xl:mb-0">
        <a :href="route('sizing-calculator.export-all', [{'assembly': exportAssembly}, {'recipe' : exportRecipe, 'recipeStudentCount': recipeStudentCount, 'searchRecipe' : exportRecipeSearced, 'recipeCurrentStudentCount':recipeCurrentStudentCount, 'type':form.type, 'site':form.site, 'date':form.date }])" target="_blank" class="button-color flex items-center justify-center w-full sm:w-auto text-white font-bold h-10 rounded px-4 whitespace-nowrap shadow-sm">
          Export Selected
        </a>
      </div>
    </div>

    </div>


    <!-- <TableFilterLayout @messageFromChild="recipeSearchData" :searchVal="rec_searched"/> -->

    <TableIndexLayout>
      <div class="-my-2 mb-0">
        <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full pb-0">
          <div class="shadow mb-10 overflow-auto">
            <table class="min-w-full">
          <thead class="header-bg-color">
            <tr>
              <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative flex items-center">
                <input type="checkbox" v-model="selectAllChecked" class="focus:ring-blue-500 h-6 w-6 text-blue-600 border-2 border-gray-300 rounded mr-2" />
                
              </th>
              <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                Recipe
              </th>
              <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                <!-- Current Count -->
                Current Yield of Recipe
              </th>
              <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                <!-- Override Count -->
                Override Yield of Recipe
              </th>
            </tr>
          </thead>
          <tbody>


            <tr v-if="!getDateRecipe && getSearchedData.length == 0 && getConvertData.length == 0" class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">Please enter recipe name or select date, site, offering</td>
            </tr>

            <tr v-if="getDateRecipe && getSearchedData.length == 0 && getConvertData.length == 0" class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">No Record Found</td>
            </tr>


            <!-- Odd row -->
            <!-- Sites -->
            <tr v-if="this.form.type != 'group'" v-for="(option,index) in getConvertData" :key="option.is_type + '_' + option.id" :class="{'bg-white':index%2 == 0, 'tr-background-color':index%2 != 0}">

                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                  <input v-if="option.is_type == 'option'" class="focus:ring-blue-500 h-6 w-6 text-blue-600 border-2 border-gray-300 rounded" :checked="isItemSelected(option)" @click.stop="toggleSelection(option)" type="checkbox" />
                  <input v-else class="focus:ring-blue-500 h-6 w-6 text-blue-600 border-2 border-gray-300 rounded" :checked="isItemSelected(option)" @click.stop="toggleSelection(option)" type="checkbox" />

                </td>
                <td v-if="option.is_type == 'option'" class="text px-6 py-4 cursor-pointer hover:underline" @click="toggleSelection(option)">
                  <b>{{ option.name }}</b>
                </td>
                <td v-else class="px-6 py-4 cursor-pointer hover:underline" @click="toggleSelection(option)">
                 {{ option.recipe.name }}
                </td>

                <td v-if="option.is_type == 'option'" class="px-6 py-4 "></td>
                <td v-else class="px-6 py-4 ">{{ option.student_count }}</td>

                <td v-if="option.is_type == 'option'" class="px-6 py-4"></td>
                <td v-else class=" px-6 py-4"><input type="text" class="border-gray-300 rounded w-20" v-model="recipeStudentCount[option.id]" ></td>

                <td class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl" v-if="option.is_type == 'option'" >
                  <a target="_blank" :href="route('sizing-calculator.download-assembly-instructions', option.id)" ><i class="fa fa-external-link" aria-hidden="true"></i></a>
                </td>
                <td v-else class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                  <a target="_blank" :href="route('sizing-calculator.download-recipe-card', [option.id , recipeStudentCount[option.id]])" ><i class="fa fa-external-link" aria-hidden="true"></i></a>
                </td>
            </tr>

            <!-- Groups -->
            <tr v-if="this.form.type == 'group'" v-for="(option,index) in getConvertData" :key="option.is_type + '_' + option.id" :class="{'bg-white':index%2 == 0, 'tr-background-color':index%2 != 0}">

                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                  <input v-if="option.is_type == 'option'" class="focus:ring-blue-500 h-6 w-6 text-blue-600 border-2 border-gray-300 rounded" :checked="isItemSelected(option)" @click.stop="toggleSelection(option)" type="checkbox" />
                  <input v-else class="focus:ring-blue-500 h-6 w-6 text-blue-600 border-2 border-gray-300 rounded" :checked="isItemSelected(option)" @click.stop="toggleSelection(option)" type="checkbox" />

                </td>
                <td v-if="option.is_type == 'option'" class="text px-6 py-4 cursor-pointer hover:underline" @click="toggleSelection(option)">
                  <b>{{ option.name }} </b>
                </td>
                <td v-else class="px-6 py-4 cursor-pointer hover:underline" @click="toggleSelection(option)">
                  {{ option.recipe.name }}

                </td>

                <td v-if="option.is_type == 'option'" class="px-6 py-4 "></td>
                <td v-else class="px-6 py-4 ">
                  <div class="onhover relative cursor-pointer">
                  {{ option.student_count }}
                  <div class="recipe_name_list absolute top-8 left-0 rounded-sm bg-white p-3 shadow-lg w-48 z-20">
                    <label v-for="(sName, index) in option.sites">
                      {{ showSiteName(index) }} - {{ showCount(sName) }}<br>
                    </label>
                   </div>
                 </div>
                 </td>

                <td v-if="option.is_type == 'option'" class="px-6 py-4"></td>
                <td v-else class=" px-6 py-4"><input type="text" class="border-gray-300 rounded w-20" v-model="recipeStudentCount[option.id]" ></td>

                <td class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl" v-if="option.is_type == 'option'" >
                  <a target="_blank" :href="route('sizing-calculator.download-assembly-instructions', option.id)+'?type=group&site='+form.site + '&date='+ form.date" ><i class="fa fa-external-link" aria-hidden="true"></i></a>
                </td>
                <td v-else class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                  <a target="_blank" :href="route('sizing-calculator.download-recipe-card', [option.id , (recipeStudentCount[option.id])?recipeStudentCount[option.id]:option.student_count ])" ><i class="fa fa-external-link" aria-hidden="true"></i></a>
                </td>
            </tr>

            <!-- Search Result -->

            <tr v-if="getSearchedData.length > 0" v-for="(option,index) in getSearchedData" :key="'search_' + option.id" :class="{'bg-white':index%2 == 0, 'tr-background-color':index%2 != 0}">
              <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                  <input class="focus:ring-blue-500 h-6 w-6 text-blue-600 border-2 border-gray-300 rounded" :checked="isItemSelected(option)" @click.stop="toggleSelection(option)" type="checkbox" />
              </td>
              <td class="px-6 py-4 cursor-pointer hover:underline" @click="toggleSelection(option)">
                {{ option.name }}
              </td>
              <td class="px-6 py-4">0</td>
              <td class=" px-6 py-4">
                <input type="text" class="border-gray-300 rounded w-20" v-model="recipeStudentCount[option.id]" >
              </td>
              <td class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                <a target="_blank" :href="route('sizing-calculator.download-card', [option.id , recipeStudentCount[option.id]])" ><i class="fa fa-external-link" aria-hidden="true"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>


    </TableIndexLayout>
  </default-layout>
</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import Paginate from "@/Pages/Partials/Paginate";
import Option from '../MenuCycle/Option.vue';

export default {
  props:['sites', 'mealPreparationGroups'],
  components: {
    DefaultLayout,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    Paginate
  },
  data(){
    return {
      recipes:[],
      searchResults:[],
      offerings:[],
      options:{},
      exportRecipe:[],
      exportRecipeSearced:[],
      exportAssembly:[],
      recipeStudentCount:[],
      recipeCurrentStudentCount:[],
      searchByName:'',
      searchSuggestions:[],
      showSuggestions:false,
      searchDebounceTimer: null,
      addedManualSearchItemIds: [],
      knownItems: {},
      pinnedItems: [],
      pinnedSearchItems: [],
      form: {
        date:'',
        site: '',
        offer: '',
        type:''
      },
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {

      getDateRecipe:function () {
          return (this.form.date != '' && this.form.site != '' && (this.form.offer != '' || this.form.type == 'group' ) );
      },
      getConvertData: function () {
        let recpArray = [];
        let addedKeys = new Set();
        
        const addItem = (item, type, originalId) => {
           let key = `${type}_${originalId}`;
           if (!addedKeys.has(key)) {
               addedKeys.add(key);
               item.is_type = type;
               recpArray.push(item);
           }
        };

        // Always show pinned items first (survive filter changes / unchecking)
        this.pinnedItems.forEach(item => {
           this.knownItems[`${item.is_type}_${item.id}`] = item;
           addItem(item, item.is_type, item.id);
        });

        // Then show fresh recipe results
        this.recipes.forEach(rec => {
          this.knownItems[`option_${rec.id}`] = rec;
          addItem(rec, 'option', rec.id);

          if(rec.menu_cycle_day_option_components){
            let a = this.sortedArray(rec.menu_cycle_day_option_components);
            a.forEach(ra => {
              this.knownItems[`recipe_${ra.id}`] = ra;
              addItem(ra, 'recipe', ra.id);
            })
          }
        });
        
        // Finally, show any other selected items not already in the list
        this.exportAssembly.forEach(id => {
           let item = this.knownItems[`option_${id}`];
           if (item) addItem(item, 'option', id);
        });
        this.exportRecipe.forEach(id => {
           let item = this.knownItems[`recipe_${id}`];
           if (item) addItem(item, 'recipe', id);
        });

        return recpArray;
      },

      getSearchedData: function() {
        let results = [];
        let addedKeys = new Set();

        // Pinned search items always show regardless of check state
        this.pinnedSearchItems.forEach(item => {
           this.knownItems[`search_${item.id}`] = item;
           if (!addedKeys.has(item.id)) {
               addedKeys.add(item.id);
               results.push(item);
           }
        });

        // Manual search selections (suggestion clicks)
        this.addedManualSearchItemIds.forEach(id => {
           let item = this.knownItems[`search_${id}`];
           if (item && !addedKeys.has(id)) {
               addedKeys.add(id);
               results.push(item);
           }
        });

        // Live search results
        this.searchResults.forEach(item => {
           this.knownItems[`search_${item.id}`] = item;
           if (!addedKeys.has(item.id)) {
               addedKeys.add(item.id);
               results.push(item);
           }
        });

        // Finally, show any other selected items not already in the list
        this.exportRecipeSearced.forEach(id => {
           let item = this.knownItems[`search_${id}`];
           if (item && !addedKeys.has(id)) {
               addedKeys.add(id);
               results.push(item);
           }
        });

        return results;
      },

      selectAllChecked: {
        get() {
          const convertItems = this.getConvertData;
          const searchItems = this.getSearchedData;
          
          if (convertItems.length === 0 && searchItems.length === 0) return false;
          
          const allConvertSelected = convertItems.every(item => {
            if (item.is_type === 'option') return this.exportAssembly.includes(item.id);
            if (item.is_type === 'recipe') return this.exportRecipe.includes(item.id);
            return false;
          });

          const allSearchSelected = searchItems.every(item => {
            return this.exportRecipeSearced.includes(item.id);
          });

          return allConvertSelected && allSearchSelected;
        },
        set(value) {
          if (value) {
            this.getConvertData.forEach(item => {
               if (item.is_type === 'option') {
                  if (!this.exportAssembly.includes(item.id)) this.exportAssembly.push(item.id);
               } else if (item.is_type === 'recipe') {
                  if (!this.exportRecipe.includes(item.id)) this.exportRecipe.push(item.id);
               }
            });
            this.getSearchedData.forEach(item => {
               if (!this.exportRecipeSearced.includes(item.id)) this.exportRecipeSearced.push(item.id);
            });
          } else {
            this.getConvertData.forEach(item => {
               if (item.is_type === 'option') {
                  let idx = this.exportAssembly.indexOf(item.id);
                  if (idx > -1) this.exportAssembly.splice(idx, 1);
               } else if (item.is_type === 'recipe') {
                  let idx = this.exportRecipe.indexOf(item.id);
                  if (idx > -1) this.exportRecipe.splice(idx, 1);
               }
            });
            this.getSearchedData.forEach(item => {
               let idx = this.exportRecipeSearced.indexOf(item.id);
               if (idx > -1) this.exportRecipeSearced.splice(idx, 1);
            });
          }
        }
      },

  },
  watch: {
    'form.date': function() {
      this.removeUncheckedItems();
      if (this.getDateRecipe) this.getDateRecipeData();
    },
    'form.site': function() {
      this.removeUncheckedItems();
      if (this.getDateRecipe) this.getDateRecipeData();
    },
    'form.offer': function() {
      this.removeUncheckedItems();
      if (this.getDateRecipe) this.getDateRecipeData();
    },
    'form.type': function() {
      this.removeUncheckedItems();
      if (this.getDateRecipe) this.getDateRecipeData();
    },
  },
  methods:{

    sortedArray(recipe_arrays) {
      // console.log("recipe_arrays", recipe_arrays);
      let a= _.orderBy(recipe_arrays, 'recipe.name', 'asc');
      a= _.orderBy(a, 'recipe.category_sort', 'asc');
      return a;
    },

    showCount(sc){
      if(isNaN(sc)){
        return 'N/A';
      } else if(sc >= 1) {
        return sc;
      } else if(sc === 0){
        return 0;
      } else{
        return 'N/A';
      }
    },

    resetSeatch(){
        // Snapshot currently checked items so they remain visible after reset
        this.pinnedItems = this.getConvertData.filter(item => {
          if (item.is_type === 'option') return this.exportAssembly.includes(item.id);
          if (item.is_type === 'recipe') return this.exportRecipe.includes(item.id);
          return false;
        });

        this.pinnedSearchItems = this.getSearchedData.filter(item =>
          this.exportRecipeSearced.includes(item.id)
        );

        // Keep only manually-added IDs that are still checked
        this.addedManualSearchItemIds = this.addedManualSearchItemIds.filter(id =>
          this.exportRecipeSearced.includes(id)
        );

        this.form = {
              date:'',
              site: '',
              offer: '',
              type:''
            };
        this.recipes = [];
        this.searchResults = [];
        this.offerings = [];
        this.options = {};
        this.recipeStudentCount = [];
        this.searchByName = "";
        this.searchSuggestions = [];
        this.showSuggestions = false;
      },

    removeUncheckedItems() {
      this.pinnedItems = this.pinnedItems.filter(item => {
        if (item.is_type === 'option') return this.exportAssembly.includes(item.id);
        if (item.is_type === 'recipe') return this.exportRecipe.includes(item.id);
        return false;
      });

      this.pinnedSearchItems = this.pinnedSearchItems.filter(item =>
        this.exportRecipeSearced.includes(item.id)
      );

      this.addedManualSearchItemIds = this.addedManualSearchItemIds.filter(id =>
        this.exportRecipeSearced.includes(id)
      );
    },

        getRecipeStudentCount(){
          let $this = this;
          this.recipeStudentCount  = [];
          this.recipeCurrentStudentCount = [];
          this.recipes.forEach(rec => {
          if(rec.menu_cycle_day_option_components){
            rec.menu_cycle_day_option_components.forEach(ra => {
              ra.is_type = 'recipe';
              $this.recipeStudentCount[ra.id] = null;
              $this.recipeCurrentStudentCount[ra.id] = ra.student_count;
            })
          }
        });
        console.log("recipeStudentCount", this.recipeStudentCount);
        },
        getSearchRecipeStudentCount(){
          let $this = this;
          this.recipeStudentCount  = [];
          this.recipeCurrentStudentCount = [];
          console.log("searchResults", this.searchResults);
          this.searchResults.forEach(rec => {
            $this.recipeStudentCount[rec.id] = null;
            $this.recipeCurrentStudentCount = [];
          });
          console.log("recipeStudentCount", this.recipeStudentCount);
        },

        showSiteName(site_id){
          console.log("siteName", this.siteName);
          return (this.siteName[site_id])?this.siteName[site_id]:site_id;
        },

        getDateRecipeData(){
            console.log("getDateRecipeData", this.form);
            let $this = this;
            axios
            .get(this.route('get-sizing-calculator-data',  this.form))
            .then((response) => {
              this.searchResults = [];
              console.log("response.data", response.data);
              if(response.data.status){
                // Replaced clearing of exportRecipe and exportAssembly
                // this.exportRecipe = [];
                // this.exportAssembly = [];
                this.options = response.data;
                if(response.data.data){
                  $this.siteName = response.data.sites;
                  $this.recipes = [];
                  if(response.data.type == 'group'){

                    // this.recipes = response.data.data.menu_cycle_day_options;
                    response.data.data.forEach(rec => {
                      $this.recipes.push(rec);
                      // $this.recipes = rec.menu_cycle_day_options;
                    });
                  } else {
                    response.data.data.forEach(rec => {
                      rec.menu_cycle_day_options.forEach(opRec => {
                        $this.recipes.push(opRec);
                      });
                      // $this.recipes = rec.menu_cycle_day_options;
                    });
                  }


                }
                // this.recipes = response.data.data.menu_cycle_day_options;
                this.getRecipeStudentCount();
              } else {
                this.recipes = [];
                // Preserved checked states by NOT clearing exportRecipe / exportAssembly
              }

            })
          .catch((error) => console.error(error));
        },

        getOffering(event){
           var options = event.target.options;
           console.log("options", options);
           var type = '';
          if (options.selectedIndex > -1) {
            type = options[options.selectedIndex].getAttribute('type');
            console.log("type ", type );
          }
          this.form.type = type;
          console.log("this.form", this.form);

          if(this.form.type == 'group'){
            this.getDateRecipeData();
            this.offerings = [];
          } else {
            let sid = this.form.site;
          let site = this.sites.find(o => o.id === sid);
          if(site){
              this.offerings = site.offerings;
          } else {
              this.offerings = [];
          }
          this.form.offer = '';
          }


        },
      recipeSearchData(){
        this.showSuggestions = false;
        axios.post('/recipe-search-filter',{type:'search',search:this.searchByName})
          .then((response)=>{
            this.recipes = [];
            this.searchResults = response.data.data;
              this.getSearchRecipeStudentCount();
            })
          .catch(error => console.error(error));
      },
       onQueryChange(event) {
        clearTimeout(this.searchDebounceTimer);
        if(event.target.value.trim().length === 0) {
          this.searchSuggestions = [];
          this.showSuggestions = false;
        } else {
          this.searchDebounceTimer = setTimeout(() => {
            // fetch suggestions without resetting main view
            axios.post('/recipe-search-filter',{type:'search',search:this.searchByName})
              .then((response)=>{
                this.searchSuggestions = response.data.data;
                this.showSuggestions = true;
              })
              .catch(error => console.error(error));
          }, 500);
        }
      },
      toggleSelectionFromSuggestion(option) {
         this.knownItems[`search_${option.id}`] = option;
         
         const isCurrentlySelected = this.isRecipeSelected(option);
         
         if (isCurrentlySelected) {
            // Remove from manual items list so it disappears from the table if it's not a live search result
            const manualIdx = this.addedManualSearchItemIds.indexOf(option.id);
            if (manualIdx > -1) {
               this.addedManualSearchItemIds.splice(manualIdx, 1);
            }
         } else {
            // Add to manual items list so it appears in the table
            if (!this.addedManualSearchItemIds.includes(option.id)) {
               this.addedManualSearchItemIds.push(option.id);
            }
         }
         
         this.toggleSelection(option);
      },
      isItemSelected(item) {
         if (item.is_type === 'option') {
            return this.exportAssembly.includes(item.id);
         }
         return this.isRecipeSelected(item);
      },
      isRecipeSelected(item) {
         if (item.is_type === 'recipe') {
            return this.exportRecipe.includes(item.id);
         }
         
         // For search results or suggestions
         const recipeId = item.id;
         return this.exportRecipeSearced.includes(recipeId);
      },
      toggleSelection(option) {
         if (option.is_type === 'option') {
            this.toggleArrayItem(this.exportAssembly, option.id);
            return;
         }

         if (option.is_type === 'recipe') {
            this.toggleArrayItem(this.exportRecipe, option.id);
            if (this.exportRecipe.includes(option.id)) {
               this.recipeStudentCount[option.id] = null;
            }
            return;
         }

         // For search results (suggestions or manual search)
         const recipeId = option.id;
         this.toggleArrayItem(this.exportRecipeSearced, recipeId);
         if (this.exportRecipeSearced.includes(recipeId)) {
            this.recipeStudentCount[recipeId] = null;
         }
      },
      toggleArrayItem(arr, id) {
         const index = arr.indexOf(id);
         if (index > -1) {
            arr.splice(index, 1);
         } else {
            arr.push(id);
         }
      },
      handleClickOutside(event) {
        if (this.$refs.searchContainer && !this.$refs.searchContainer.contains(event.target)) {
          this.showSuggestions = false;
          this.searchByName = '';
          this.searchSuggestions = [];
          this.searchResults = [];
        }
      }
  },
};
</script>
<style>
.id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 17px;
    left: 55px;
    padding-left:7px;
    color: #219FD5;
}

.id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left:7px;
    position: absolute;
    top: 17px;
    left: 55px;
}

.max-height-screen{
  max-height: calc(100vh - 380px);
}
.trim_text {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
}

.tooltip {
    display:inline-block;
    position:relative;
    text-align:left;
}
.tooltip .top {
    width: 250px;
    top:50%;
    left:100%;
    margin-left:20px;
    transform:translate(0, -50%);
    padding: 5px 10px;
    color: #444444;
    background-color: #EEEEEE;
    font-weight: normal;
    font-size: 14px;
    border-radius: 5px;
    position: absolute;
    z-index: 99999999;
    box-sizing: border-box;
    box-shadow: 0 1px 8px rgba(0,0,0,0.5);
    display: none;
    white-space: normal;
}
.tooltip:hover .top {
    display:block;
}
.tooltip .top i {
    position:absolute;
    top:50%;
    right:100%;
    margin-top:-12px;
    width:12px;
    height:24px;
    overflow:hidden;
}
.tooltip .top i::after {
    content:'';
    position:absolute;
    width:12px;
    height:12px;
    left:0;
    top:50%;
    transform:translate(50%,-50%) rotate(-45deg);
    background-color:#EEEEEE;
    box-shadow:0 1px 8px rgba(0,0,0,0.5);
}
.cart-color {
    color: #f7a53a;
}
.recipe_name_list{
  display: none;
}
.onhover:hover .recipe_name_list{
  display: block;
}
table.min-w-full tr:last-child .recipe_name_list {
    top: auto;
    bottom: 32px;
}
</style>
